import React  from 'react'
import {Redirect, Route, Switch} from 'react-router-dom';
import {EmployeeStep} from '../Authenticated/Employee/EmployeeStep/EmployeeStep';
import {EmployerStep} from '../Authenticated/Employer/EmployerStep/EmployerStep';
import {Footer} from '../components/Footer/Footer';
import {CompanyPage} from '../UnAuthenticated/Company/CompanyPage';
import {Home} from '../UnAuthenticated/Home/Home';
import {Login} from '../UnAuthenticated/Login/Login';
import {RegisterEmployee} from '../UnAuthenticated/Register/Employee/RegisterEmployee';
import {RegisterEmployer} from '../UnAuthenticated/Register/Employer/RegisterEmployer';
import {Register} from '../UnAuthenticated/Register/Register';
import {Header} from "../components/Header/Header";
import {HomeJobs} from "../UnAuthenticated/HomeJobs/HomeJobs";
import {IUserData} from '../State/Register/UserDataSlice'
import {useSelector} from "react-redux";
import {IRootState} from "../State/Store";
import {NotFound} from "../components/NotFound/NotFound";
import PrivacyPolicy from '../PrivacyPolicy'
import {UnAuthenticatedJob} from "../UnAuthenticated/UnAuthenticatedJob/UnAuthenticatedJob";
// import {ContactUs} from "../UnAuthenticated/Home/ContactUS";
import EmailActivation from '../Authenticated/Employer/EmailActivation/EmailActivation';
import ResetPassword from '../UnAuthenticated/reset/ResetPassword';
import ForgetPassword from '../UnAuthenticated/reset/ForgetPassword';
// import { useParams } from 'react-router-dom'
const UnAuthenticated: React.FC = () => {
    const UserData: IUserData | null = useSelector((s: IRootState) => s.UserData);
    // const handle:string  = useParams();
    // useEffect(()=>{  
    //     const  ContactUs: HTMLElement|null  = document.querySelector("#ContactUs");
    //     const  footer: HTMLElement|null  = document.querySelector("#footer");
 
    //     function checkOffset() {
    //         if(!(ContactUs != null && footer != null)) {
    //             return;
    //         }
    //         function getRectTop(el: HTMLElement) {
    //             var rect: DOMRect = el.getBoundingClientRect();
    //             return rect.top;
    //         }
    
    //         if( getRectTop(ContactUs) + document.body.scrollTop + ContactUs.offsetHeight >= getRectTop(footer) + document.body.scrollTop - 10 )
    //            {
    //             ContactUs.style.bottom = "100px";
    //            }
    //         if( document.body.scrollTop + window.innerHeight < getRectTop(footer) + document.body.scrollTop  )
    //            { ContactUs.style.bottom = "15px";}
    
    //     }
    
    //     document.addEventListener("scroll", function () {
    //         checkOffset();
    //     });
    // },[handle]);
    return (
            <React.Fragment>

                {/*color={useLocation().pathname==="/"?'':'#1D252D'}*/}
                {/* {(!window.location.href.includes("404")&&!window.location.href.includes("register")) && <ContactUs/>} */}
                <Switch>
                    <Redirect exact from='/employer/home' to='/'/>
                    <Redirect exact from='/employee/home' to='/'/>
                    <Redirect exact from='/logout' to='/'/>

                    <Route path='/' exact>

                        <Home/>
                        <Footer/>

                    </Route>
                    <Route path='/jobs' exact>
                        <Header/>
                        <HomeJobs/>
                        <Footer/>


                    </Route>
                    <Route path='/jobs/graduates' exact>
                        <Header/>
                        <HomeJobs exp={'622deb54b856595a6ccd8b23'}/>
                        <Footer/>


                    </Route>
                    <Route path='/mail/:type/:id' exact component={EmailActivation}/>
                    <Route path='/job/:id' exact>
                        <Header/>
                        <UnAuthenticatedJob/>
                        <Footer/>

                    </Route>

                    <Route path='/company/:id' exact>

                        <CompanyPage/>
                        <Footer/>
                    </Route>
                    <Route path='/login' exact component={Login}/>
                    <Route path='/privacy' exact component={PrivacyPolicy}/>
                    <Route path='/company' exact>
                        <Header/>
                        <CompanyPage/>
                        <Footer/>

                    </Route>
                    <Route path='/register' exact component={Register}/>
                    <Route path='/register/employee' exact component={RegisterEmployee}/>
                    <Route path='/register/employer' exact component={RegisterEmployer}/>
                    <Route path='/employer/step' exact component={EmployerStep}/>
                    <Route path='/reset/:id' exact component={ResetPassword}/>
                    <Route path='/forget/' exact component={ForgetPassword}/>
                    <Route path='/employee/step' exact>
                        {UserData?.name !== undefined ? <EmployeeStep/> :
                                <Redirect from='/employee/step' to='/register/employee'/>}
                    </Route>

                    <Redirect exact from='/jobs/:id' to='/job/:id'/>
                    <Route path='/404' exact component={NotFound}/>


                    <Redirect from='*' to='/404'/>


                </Switch>
            </React.Fragment>
    )
}
export default UnAuthenticated